import { CustomSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/types';
import { createImageSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/carouselSlide.util';

export const CandyCaneItems: CustomSlide[] = [
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/candyCane/candyCane1%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/candyCane/candyCane2%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/candyCane/candyCane3%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/candyCane/candyCane4%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/candyCane/candyCane5%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/candyCane/candyCane6%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/candyCane/candyCane7%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/candyCane/candyCane8%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/candyCane/candyCane9%401x.png'
    ),
];
